import * as React from "react"

const RweMiddleNok = (props) => (
    <svg
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M399 385.408c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24Z"
            fill="#B5179E"
        />
        <path
            d="M420.5 392.408c10.77 0 19.5-8.731 19.5-19.5 0-10.77-8.73-19.5-19.5-19.5s-19.5 8.73-19.5 19.5c0 10.769 8.73 19.5 19.5 19.5Z"
            fill="#560BAD"
        />
        <path
            d="M353.5 385.408c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5ZM323 374.408c6.075 0 11-4.701 11-10.5s-4.925-10.5-11-10.5-11 4.701-11 10.5 4.925 10.5 11 10.5Z"
            fill="#F72585"
        />
        <path
            d="M370.5 440.408c13.531 0 24.5-10.745 24.5-24s-10.969-24-24.5-24-24.5 10.745-24.5 24 10.969 24 24.5 24Z"
            fill="#560BAD"
        />
        <path
            d="M392 466.408c16.016 0 29-12.984 29-29s-12.984-29-29-29-29 12.984-29 29 12.984 29 29 29Z"
            fill="#7209B7"
        />
        <path
            d="M441.5 435.408c14.636 0 26.5-11.865 26.5-26.5 0-14.636-11.864-26.5-26.5-26.5s-26.5 11.864-26.5 26.5c0 14.635 11.864 26.5 26.5 26.5Z"
            fill="#7209B7"
        />
        <path
            d="M499 437.408c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21Z"
            fill="#B5179E"
        />
        <path
            d="M462.5 392.408c10.77 0 19.5-8.731 19.5-19.5 0-10.77-8.73-19.5-19.5-19.5s-19.5 8.73-19.5 19.5c0 10.769 8.73 19.5 19.5 19.5Z"
            fill="#7209B7"
        />
        <path
            d="M451 465.408c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25Z"
            fill="#951E83"
        />
        <path
            d="M487.5 476.408c7.456 0 13.5-6.044 13.5-13.5s-6.044-13.5-13.5-13.5-13.5 6.044-13.5 13.5 6.044 13.5 13.5 13.5Z"
            fill="#F72585"
        />
        <path
            d="M421 491.408c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Z"
            fill="#A51991"
        />
        <path
            d="M466.5 499.408c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5ZM311 467.408c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11ZM359 459.408c8.837 0 16-6.94 16-15.5 0-8.561-7.163-15.5-16-15.5s-16 6.939-16 15.5c0 8.56 7.163 15.5 16 15.5ZM352 473.408a5 5 0 1 0-.001-10.001 5 5 0 0 0 .001 10.001Z"
            fill="#B5179E"
        />
        <path
            d="M393.5 418.408c12.979 0 23.5-10.521 23.5-23.5s-10.521-23.5-23.5-23.5-23.5 10.521-23.5 23.5 10.521 23.5 23.5 23.5Z"
            fill="#7209B7"
        />
        <path
            d="M414.5 438.408c10.77 0 19.5-8.731 19.5-19.5 0-10.77-8.73-19.5-19.5-19.5s-19.5 8.73-19.5 19.5c0 10.769 8.73 19.5 19.5 19.5Z"
            fill="#B5179E"
        />
        <path
            d="M423.5 444.408c6.904 0 12.5-5.82 12.5-13s-5.596-13-12.5-13-12.5 5.82-12.5 13 5.596 13 12.5 13Z"
            fill="#B5179E"
        />
        <path
            d="M371.5 522.408a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
            fill="#7209B7"
        />
        <path
            d="M472.5 420.408c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5ZM379 316.408c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10ZM451.5 368.408c8.56 0 15.5-6.94 15.5-15.5 0-8.561-6.94-15.5-15.5-15.5-8.56 0-15.5 6.939-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5ZM454.5 332.408c3.59 0 6.5-2.686 6.5-6s-2.91-6-6.5-6-6.5 2.686-6.5 6 2.91 6 6.5 6Z"
            fill="#B5179E"
        />
        <path
            d="M428 353.408c7.18 0 13-6.044 13-13.5s-5.82-13.5-13-13.5-13 6.044-13 13.5 5.82 13.5 13 13.5Z"
            fill="#B5179E"
        />
        <path
            d="M508.5 386.408c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5ZM487.5 350.408a8.5 8.5 0 1 0-.001-17.001 8.5 8.5 0 0 0 .001 17.001ZM404.5 356.408c6.904 0 12.5-5.597 12.5-12.5 0-6.904-5.596-12.5-12.5-12.5s-12.5 5.596-12.5 12.5c0 6.903 5.596 12.5 12.5 12.5ZM393.5 465.408c6.904 0 12.5-5.597 12.5-12.5 0-6.904-5.596-12.5-12.5-12.5s-12.5 5.596-12.5 12.5c0 6.903 5.596 12.5 12.5 12.5Z"
            fill="#F72585"
        />
        <path
            d="M510 239.408H317c-39.212 0-71 31.788-71 71v183c0 39.212 31.788 71 71 71h193c39.212 0 71-31.788 71-71v-183c0-39.212-31.788-71-71-71Z"
            fill="#191822"
            style={{
                mixBlendMode: "color",
            }}
            opacity={0.638}
        />
    </svg>
)

export default RweMiddleNok
